import type { PermissionCatalog } from '@ztechapps/common.contract'
import { appShellPermissions } from '@ztechapps/common.contract'
import { aiPermissions } from '@ztechapps/ai.common'
import { blogPermissions } from '@ztechapps/blog.common'
import { chatPermissions } from '@ztechapps/chat.common'
import { quickscorePermissions } from './quickscorePermissions'

// Array order is display order in the Set Permissions modal.
//
// NOTE: `quickscore.canAccess` (the teacher-facing QuickScore app permission) is deliberately
// NOT in this catalog — the QuickScore Admin permission model only manages admin-app access.
// `quickscoreAdmin.canAccess` is the permission that grants entry to the admin app itself.
export const quickscorePermissionCatalog: PermissionCatalog = [
  {
    label: 'QuickScore Admin',
    permissions: [quickscorePermissions.quickscoreAdmin.canAccess],
  },
  {
    label: 'History',
    permissions: [appShellPermissions.history.canView],
  },
  {
    // `setting.canEdit` is the gate that `setRole` (SetUserRole -> CanEditSettingValidator)
    // and the Set Permissions screen (client-side) both require. Exposing it here lets a
    // staff admin who already holds it grant/revoke it, so permission management is
    // reachable within the QuickScore admin permission model rather than only via out-of-band
    // bootstrap. The group also gates the Coupons and Model Rates Settings tabs: `canView`
    // opens a tab, `canEdit` changes or deletes a row on it.
    label: 'Settings',
    permissions: [appShellPermissions.setting.canView, appShellPermissions.setting.canEdit],
  },
  {
    label: 'Help Articles',
    permissions: [blogPermissions.canView, blogPermissions.canEdit, blogPermissions.canDelete],
  },
  {
    label: 'AI',
    permissions: [aiPermissions.canManageAiBilling],
  },
  {
    label: 'Conversation',
    permissions: [chatPermissions.canView, chatPermissions.canEdit],
  },
]
